<template>
  <div class="header-info" v-if="scoreExamInfo">
    <div class="paper-info">
      <div class="paper-info-title">{{ scoreExamInfo.subjectName }}</div>
      <div class="paper-info-settings">
        <van-switch v-model="checked" size="12px" inactive-color="#dcdee0" />
        <div class="paper-info-settings-text">仅显示错题</div>
        <div class="paper-info-settings-item">
          <van-switch
            v-model="visiableAnalysis"
            size="12px"
            inactive-color="#dcdee0"
          />
          <div class="paper-info-settings-text">显示解析</div>
        </div>
      </div>
    </div>
    <div class="paper-desc">
      <div class="flex-shrink-0">
        {{ dayjs(scoreExamInfo.startTime).format("YYYY/MM/DD HH:mm") }} -
        {{ dayjs(scoreExamInfo.endTime).format("YYYY/MM/DD HH:mm") }}
      </div>
      <div class="perm">准考证号：{{ scoreExamInfo.perm }}</div>
    </div>
  </div>
  <div
    v-for="section in viewQuestions"
    :key="section.id"
    style="background-color: #f4f4f4"
  >
    <div v-for="group in section.groups" :key="group.id">
      <div class="paper-group">
        <div class="paper-group-name">
          {{ group.name }} {{ group.description }}
        </div>
        <!-- <div class="paper-group-desc" v-if="!checked">
          （共{{ group.items.length }}题 共{{ group.point }}分）
        </div> -->
      </div>
      <div v-for="card in group.items" :key="card.id">
        <div v-if="card.type === 'mq-lr'" style="margin-bottom: 20px">
          <div class="question-main_stem" v-html="card.content.main_stem"></div>
          <div v-for="item in card.content.items" :key="item.id">
            <selection-card
              :visiableAnalysis="visiableAnalysis"
              :info="item"
            ></selection-card>
          </div>
        </div>
        <selection-card
          v-else
          :info="card"
          :visiableAnalysis="visiableAnalysis"
        ></selection-card>
      </div>
    </div>
  </div>
</template>
<script setup>
import { ref, reactive, computed } from "vue";
import dayjs from "dayjs";
import { useStore } from "vuex";
import selectionCard from "./components/selectionCard.vue";
import cloneDeep from "lodash/cloneDeep";
import { useRoute } from "vue-router";
import { getScoreDetailReport } from "../../api/index";

const route = useRoute();
const store = useStore();
const checked = ref(true);
const visiableAnalysis = ref(true);

const scoreExamInfo = ref(null);
const result = ref(null);
const wrongQuestions = computed(() => {
  return cloneDeep(result.value)?.sections.map((item) => {
    const filterRightQuestions = item.groups
      .map((cate) => {
        cate.items = cate.items.filter((q) => {
          if (q.type === "mq-lr") {
            q.content.items = q.content.items.filter((mq) => {
              return mq.respone.score !== mq.point;
            });
            return true;
          }
          return q.respone.score !== q.point;
        });
        return cate;
      })
      .filter((item) => {
        return item.items.length;
      });
    item.groups = filterRightQuestions;
    return item;
  });
});
const viewQuestions = computed(() => {
  return checked.value ? wrongQuestions.value : result.value?.sections || [];
});
const fetchItemDetial = () => {
  getScoreDetailReport(
    store.state.batchCode,
    store.state.perm,
    route.query.id
  ).then(({ data }) => {
    scoreExamInfo.value = data.scoreExamInfo;
    result.value = data.formItems;
  });
};
fetchItemDetial();
</script>
<style lang="scss" scoped>
.header-info {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  width: 100%;
  padding: 23px 20px;
  box-sizing: border-box;
  height: 135px;
  background: #ffffff;
  margin-top: 10px;
}
.paper-info {
  display: flex;
  justify-content: space-between;
  &-title {
    font-size: 31px;
    font-weight: 500;
    color: #0a1233;
  }
  &-settings {
    position: relative;
    display: flex;
    align-items: center;
    &-text {
      margin-left: 24px;
      font-size: 24px;
      font-weight: 500;
      color: #0a1233;
    }
  }
  .paper-info-settings-item {
    top: 60px;
    position: absolute;
    display: flex;
  }
}
.paper-desc {
  display: flex;
  margin-top: 12px;
  flex-direction: column;
  font-size: 24px;
  color: #535d85;
  gap: 10px;
  .flex-shrink-0 {
    flex-shrink: 0;
  }
  .perm {
  }
}
.paper-group {
  display: flex;
  padding: 24px 46px 24px;
  margin-top: 10px;
  background-color: #fff;
  align-items: center;
  &-name {
    font-size: 27px;
    font-weight: 600;
    color: #36426c;
    line-height: 40px;
  }
  &-desc {
    margin-left: 20px;
    font-size: 23px;
    color: #36426c;
  }
}
:deep(.question-main_stem) {
  overflow-x: auto;
  padding: 20px;
  background: #c6d9f1;
  font-size: 26px;
  color: #1c264f;
  line-height: 69px;
  justify-content: space-between;
  line-height: 36px;

  ol,
  li {
    list-style: none !important;
  }
}
</style>
